import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split('session_id=')[1]?.split('&')[0];
    const exchange = async () => {
      const { data } = await axios.post(
        `${API}/auth/session`,
        { session_id: sessionId },
        { withCredentials: true }
      );
      navigate('/account', { state: { user: data }, replace: true });
    };
    exchange().catch(() => navigate('/', { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-10 h-10 text-blue-400 animate-spin" />
    </div>
  );
}
